import { useEffect } from "react";
import { useLenis } from "@/hooks/useLenis";
import { trackEvent } from "@/lib/analytics";

import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { FourDimensions } from "@/components/landing/FourDimensions";
import { Personalization } from "@/components/landing/Personalization";
import { EODReport } from "@/components/landing/EODReport";
import { EOWReport } from "@/components/landing/EOWReport";
import { MidCTA } from "@/components/landing/MidCTA";
import { HabitLoop } from "@/components/landing/HabitLoop";
import { Marquee } from "@/components/landing/Marquee";
import { UpcomingFeatures } from "@/components/landing/UpcomingFeatures";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useLenis();

  useEffect(() => {
    trackEvent("page_view");
  }, []);

  return (
    <div className="bg-[#F8F7F3] text-[#171717] min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <FourDimensions />
        <Personalization />
        <EODReport />
        <EOWReport />
        <MidCTA />
        <HabitLoop />
        <Marquee />
        <UpcomingFeatures />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
